import CampaignService from "@/services/campaignService";

export default async function () {
  const urlParams = new URLSearchParams(window.location.search);
  const parsedTransactionId = parseTransactionId(urlParams.get('transaction_id'));
  const campaignId = urlParams.get('campaignId') ?? urlParams.get('cid') ?? parsedTransactionId?.campaignId;
  const {
    clickIdParameterName,
    publisherIdParameterName,
  } = await getCampaignConfig(campaignId);
  const publisherId = urlParams.get(`${publisherIdParameterName}`) ?? urlParams.get('publisherId') ?? parsedTransactionId?.publisherId;
  const clickId = parsedTransactionId?.clickId ?? urlParams.get(`${clickIdParameterName}`) ?? urlParams.get('ttclid') ?? urlParams.get('clickid') ?? urlParams.get('clickId') ?? urlParams.get('click_id') ?? urlParams.get('ofreqid') ?? urlParams.get('transaction_id') ?? urlParams.get('pr_mbp_clickID');
  const googleClickId = urlParams.get('gclid') ?? urlParams.get('tmt_data');
  const theme = urlParams.get('theme');
  const hmcid = urlParams.get('hmcid');

  return {
    campaignId: campaignId,
    googleClickId: googleClickId,
    clickId: clickId,
    theme: theme,
    hmcid: hmcid,
    publisherId: publisherId
  }
}

function parseTransactionId(transactionId) {
  if (!transactionId) return null;

  const parts = transactionId.split('-');
  if (parts.length < 3) return null;

  const publisherId = parts.at(-1);
  const campaignId = parts.at(-2);
  const clickId = parts.slice(0, -2).join('-');

  if (!clickId || !campaignId || !publisherId) return null;
  if (!/^\d+$/.test(campaignId) || !/^\d+$/.test(publisherId)) return null;

  return {
    clickId,
    campaignId,
    publisherId,
  };
}


async function getCampaignConfig(campaignId) {
  if(!campaignId) return {result: false}
  const {
    clickIdParameterName,
    publisherIdParameterName,
    result
  } = await CampaignService.getCampaignConfig(campaignId);
  return {
    clickIdParameterName,
    publisherIdParameterName,
    result
  }
}
